module.exports = __webpack_public_path__ + "static/media/AU-BUV-2100040_Buvidal-HCP-educational-material.38c8b304.pdf";